<template>
  <div>
    <div class="page-modal">
      <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
        :title="nodeData.name + '-' + typeName" :has-form="true" class="my-test-class" @close="close"
        @confirm="handleConfirm">
        <div class="page-form">
          <gs-form ref="form" class="form" label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称:" prop="name" class="form-item-name">
              <gs-input ref="nameInput" v-model="name" type="text" />
            </gs-form-item>
            <gs-form-item label="描述:" prop="description" class="form-item-description">
              <gs-input v-model="description" type="text" />

            </gs-form-item>
            <gs-form-item label="链接:" prop="fileLink" class="form-item-name">
              <gs-input v-model="fileLink" type="text" />

            </gs-form-item>
            <!--  <gs-form-item
              label="位置信息:"
              class="form-item-name"
            >
              <gs-input
                ref="geographyInput"
                v-model="geographyMessage"
                type="text"
              />
            </gs-form-item>
            <gs-form-item
              label="设备信息:"
              class="form-item-name"
            >
              <el-input
                type="textarea"
                autosize
                v-model="deviceMessage">
              </el-input>
            </gs-form-item> -->
          </gs-form>
        </div>
      </gs-modal>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  components: {

  },
  data() {
    return {
      loading: false,
      name: '',
      description: '',
      fileLink: '',
      initName: '',
      deviceMessage: '',
      geographyMessage: '',
      form: {
        // explain: '',
      }
    }
  },
  computed: {
    ...mapState({
      visible: 'propertiesDialogShow',
      nodeData: 'objectInfo'
    }),
    typeName() {
      let type = this.nodeData.type
      switch (type) {
        case 'root':
          return '平台'
        case 'project':
          return '项目'
        case 'folder':
          return '文件夹'
        case 'server':
          return '服务器'
        case 'logicalGroup':
          return '逻辑组'
        case 'deviceGroup':
          return '设备组'
        default:
          return ''
      }
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        this.initName = JSON.parse(JSON.stringify(this.nodeData.name))
        this.name = JSON.parse(JSON.stringify(this.nodeData.name))
        this.description = JSON.parse(JSON.stringify(this.nodeData.description))
        this.fileLink = JSON.parse(JSON.stringify(this.nodeData.fileLink))
        this.form = this.nodeData.attribute
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'PROPERTIES_DIALOG_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),
    beforeClose() {
      this.close()
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      this.loading = true
      this.nodeData.name = this.name
      this.nodeData.attribute = this.form
      this.nodeData.description = this.description
      this.nodeData.fileLink = this.fileLink
      service.renamePoint(this.nodeData).then(res => {
        this.loading = false
        this.$store.state.tabPanel = res
        this.$store.state.updateTreeNode = res
        this.$notify.success({
          message: '修改成功',
          offset: 24,
          showClose: false,
          duration: '1000'
        });
        this.close()
      }).catch(err => {
        this.loading = false
        this.nodeData.name = this.initName
        console.log(err)
        this.$notify.console.error({
          message: '修改失败',
          offset: 24,
          showClose: false,
          duration: '1000'
        });
        // this.$Message.error(err.message)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/left-side/properties.vue